import type { ClientOptionChangeEvent } from "api-types/optionCatalogs/optionCatalogHistoryResponses";
import {
  changeCell,
  dateBadgeCell,
  fieldCell,
  optionCell,
  userCell,
} from "lib/components/builders/optionHistory/optionHistoryCells";
import OptionHistoryTab from "lib/components/builders/optionHistory/OptionHistoryTab";
import { getMasterPlanOptionCatalogHistoryFiltersURL, getMasterPlanOptionCatalogHistoryURL } from "lib/endpointHelpers";
import { useAppRouterParams } from "lib/routeHelpers";
import type { OptionProps } from "ui/forms/Select/Select";
import type { Column } from "ui/tables/DataTable/types";

const changeTypeOptions: OptionProps[] = [
  { value: "CATALOG", label: "Catalog" },
  { value: "MASTER_PLAN", label: "Master Plan" },
];

const columns: Column<ClientOptionChangeEvent>[] = [
  { header: "Date", width: 0.09, enableSorting: false, cell: (ctx) => dateBadgeCell(ctx.row.original) },
  { header: "Option Set", field: "optionSetName", width: 0.15, enableSorting: false },
  { header: "Option", width: 0.15, enableSorting: false, cell: (ctx) => optionCell(ctx.row.original) },
  { header: "Field", width: 0.14, enableSorting: false, cell: (ctx) => fieldCell(ctx.row.original.field) },
  { header: "Change", width: 0.34, enableSorting: false, cell: (ctx) => changeCell(ctx.row.original) },
  { header: "User", width: 0.13, enableSorting: false, cell: (ctx) => userCell(ctx.row.original) },
];

export default function PlanLibraryHistoryTab() {
  const { builderId, masterPlanId } = useAppRouterParams();
  const resolved = builderId && masterPlanId ? { builderId, masterPlanId } : null;

  return (
    <OptionHistoryTab
      changeTypeOptions={changeTypeOptions}
      columns={columns}
      defaultRangeDays={30}
      filtersPlacement="headerSearch"
      filtersUrl={
        resolved ? getMasterPlanOptionCatalogHistoryFiltersURL(resolved.builderId, resolved.masterPlanId) : null
      }
      historyUrlFor={(filters) =>
        resolved ? getMasterPlanOptionCatalogHistoryURL(resolved.builderId, resolved.masterPlanId, filters) : null
      }
      pageSize={1000}
    />
  );
}
